import React, { ReactNode } from "react";
import { Heading, HeadingProps } from "@chakra-ui/react";

type BusinessEntitySectionTitleProps = {
  children: ReactNode;
} & HeadingProps;

const BusinessEntitySectionTitle = ({
  children,
  ...props
}: BusinessEntitySectionTitleProps) => {
  return (
    <Heading
      size={{ base: "md", md: "lg" }}
      color="brand.500"
      lineHeight="1.3"
      mb={{ base: 4, md: 5 }}
      {...props}
    >
      {children}
    </Heading>
  );
};

export default BusinessEntitySectionTitle;
